// Silk Road — Tier-B bundle (CLIENT only). Layers images over Tier-A. Generated by create-mod.
// NEVER import from Game.js / server.js / the sim / tests (pulls the keyArt PNG + globe lib).
import { silkRoadData } from './bundle.data';
import { CHARACTERS } from './characters';
import keyArt from '../dominion/keyart.png';
import { getGlobe } from '../dominion/atlas/globe-lib';
import boardBg from './backgrounds/silk-road.png';

export const silkRoadClient = Object.assign({}, silkRoadData, {
  characters: CHARACTERS,
  portraits: {},
  keyArt: keyArt,
  atlasAssets: { 'silk-road': { worldBg: boardBg, cityImages: {} } },
  getGlobe: getGlobe,
});

export default silkRoadClient;
